module.exports = __webpack_public_path__ + "static/media/footer.6b337772.jpg";